// Cuando alguien abre un link de invitación (/join?token=...) sin sesión
// iniciada, guardamos el token acá para retomar el accept apenas
// loguee/registre, en vez de perderlo en el redirect a /login.
const KEY = 'domiot:pendingShareToken';

export function savePendingShareToken(token: string): void {
  try {
    sessionStorage.setItem(KEY, token);
  } catch {
    // Ignorar: en el peor caso, el usuario tiene que volver a escanear/tocar el link.
  }
}

export function takePendingShareToken(): string | null {
  try {
    const token = sessionStorage.getItem(KEY);
    if (token) sessionStorage.removeItem(KEY);
    return token;
  } catch {
    return null;
  }
}
